import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "font-medium" }
const _hoisted_3 = { class: "flex items-center justify-end mt-3 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_time = _resolveComponent("the-time")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      class: "grid grid-cols-4 gap-4 bg-white border px-4 py-6",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createVNode(_component_the_select, {
        class: "mt-2",
        placeholder: "Скидка",
        value: _ctx.state.discountTypeId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.discountTypeId) = $event)),
        options: _ctx.discounts_state.list,
        loading: _ctx.discounts_state.is_loading,
        failed: _ctx.discounts_state.is_failed,
        searchable: false,
        "is-invalid": _ctx.state_form$.discountTypeId.$error,
        "validation-errors": _ctx.state_form$.discountTypeId.$errors,
        disabled: _ctx.is_loading,
        "error-text": "При получении скидок произошла ошибка",
        onRefresh: _ctx.loadDiscounts
      }, null, 8, ["value", "options", "loading", "failed", "is-invalid", "validation-errors", "disabled", "onRefresh"]),
      _createVNode(_component_the_select, {
        class: "mt-2",
        placeholder: "Пользователь",
        "search-without-refresh": "",
        "search-by": "fullName",
        value: _ctx.state.userId,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.userId) = $event)),
        options: _ctx.users_state.list,
        loading: _ctx.users_state.is_loading,
        failed: _ctx.users_state.is_failed,
        "is-invalid": _ctx.state_form$.userId.$error,
        "validation-errors": _ctx.state_form$.userId.$errors,
        disabled: _ctx.is_loading,
        "error-text": "При получении пользователей произошла ошибка",
        onRefresh: _ctx.loadUsers
      }, {
        "selected-option": _withCtx(({ option }) => [
          _createTextVNode(_toDisplayString(option.fullName), 1)
        ]),
        option: _withCtx(({ option }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(option.fullName), 1),
            _createElementVNode("p", null, _toDisplayString(option.phoneNumber), 1)
          ])
        ]),
        _: 1
      }, 8, ["value", "options", "loading", "failed", "is-invalid", "validation-errors", "disabled", "onRefresh"]),
      _createVNode(_component_the_input, {
        placeholder: "Дата окончания скидки",
        type: "date",
        value: _ctx.state.expirationDate,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.expirationDate) = $event)),
        "is-invalid": _ctx.state_form$.expirationDate.$error,
        "validation-errors": _ctx.state_form$.expirationDate.$errors,
        disabled: _ctx.is_loading
      }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
      _createVNode(_component_the_time, {
        placeholder: "Время окончания скидки",
        value: _ctx.state.expirationTime,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.expirationTime) = $event)),
        "is-invalid": _ctx.state_form$.expirationTime.$error,
        "validation-errors": _ctx.state_form$.expirationTime.$errors,
        disabled: _ctx.is_loading
      }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"])
    ], 32),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_button, {
        class: "primary small",
        disabled: _ctx.is_loading,
        type: "button",
        onClick: _ctx.onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Отмена ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary small",
        disabled: _ctx.is_loading,
        loading: _ctx.is_loading,
        type: "button",
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Добавить скидку к компании ")
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])
    ])
  ]))
}